export const GET_USER_BY_ID = 'app/user_management/get_user_by_user_id';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const MODIFY_USER = 'MODIFY_USER';
export const SEARCH_ROLES_SUCCESS = 'app/user_management/search_roles_success';